import ReactDOM from 'react-dom';
import { TeacherProfileProjectsController } from './TeacherProfileProjectsController.js';
import { TeacherShareBar } from './TeacherShareBar.js';
import { markTeacherViewingSelf } from '../common/markTeacherViewingSelf.js';
import { isUserTheTeacher } from '../utils/userUtils.js';
import '../teacher/profile/teacherProfile.js'; // for doc listeners
import { EssentialsListCard } from '../common/EssentialsListCard.js';
import {
    setupTeacherProfilePhotoForNormalUser,
    setupTeacherProfilePhotoForTeacherViewingTheirOwnPage,
} from '../teacher/profile/teacherProfilePhoto.js';
import {
    addClassroomDescriptionReadMoreLinkOnlyIfTooLong,
    setupEditClassroomDescriptionSection,
} from '../teacher/profile/profileDescForTeacherProfile.js';
import { getTeacherProfileTwitterText } from '../sharebar/sharebarHelperFunctions.js';
import {
    registerUpdateClassroomPhotoOnUnderlyingPage,
} from '../teacherclassroomphoto/teacherClassroomPhotoUpdate.js';

/* global teacherId teacherName teacherPageInfo */
/* global getTafEmail */ // defined in general/sharebar.js
/* global getTrackingLink */ // defined in queryParams.js

// consider cleaning this up by extracting out separate "main" files like we do in projectPageReactMain.js
$(function () {
    if (teacherPageInfo.showEssentialsListCard) {
        ReactDOM.render(
            <div>
                <h4>Gift {teacherPageInfo.teacherNamePossessive} classroom the essentials</h4>
                <EssentialsListCard
                    teacherName={teacherName}
                    teacherId={teacherId}
                    teacherNamePossessive={teacherPageInfo.teacherNamePossessive}
                    topItemImageUrl={teacherPageInfo.essentialsTopItemImageUrl}
                    topItemName={teacherPageInfo.essentialsTopItemSummary}
                    topItemPrice={teacherPageInfo.essentialsTopItemPrice}
                    listLength={teacherPageInfo.essentialsListLength}
                    city={teacherPageInfo.city}
                    state={teacherPageInfo.state}
                    stateFullName={teacherPageInfo.stateFullName}
                    essentialsListUrl={teacherPageInfo.essentialsListUrl}
                    isMiniVersion={true}/>
            </div>,
            document.getElementById('essentials-card'),
        );
    }

    ReactDOM.render(
        <TeacherProfileProjectsController teacherId={teacherId} />,
        document.getElementById('tabs'),
    );

    setupPageDependingOnUser();
    $(window).on('userCookiesReset', function () {
        setupPageDependingOnUser();
    });
});

function setupPageDependingOnUser() {
    if (isUserTheTeacher() && window.isLoggedInOrRemembered()) {
        $('.js-admin').show();
        setupTeacherProfilePhotoForTeacherViewingTheirOwnPage(window.teacherPageInfo);
        // Do this if we upload a new classroom photo here (instead of the
        // default on-upload behavior, where we'd actually try to show the photo).
        registerUpdateClassroomPhotoOnUnderlyingPage(function () {
            // If they've uploaded a new photo, they're pending photo-screening.
            window.teacherPageInfo.classroomPhotoPendingScreening = true;
            setupTeacherProfilePhotoForTeacherViewingTheirOwnPage(window.teacherPageInfo);
        });

        $('.display-name').show();
        if (teacherPageInfo.teacherHasClassroomPhoto && teacherPageInfo.teacherHasClassroomDescription) {
            renderAndShowTeacherShareBar();
        }
        $('.js-monthly-giving').hide();
        $('.js-view-classroom-description').hide();
        setupEditClassroomDescriptionSection(teacherPageInfo.teacherClassroomDescription);
        $('.js-classroom-updates').hide();

        markTeacherViewingSelf();
    } else {
        $('.js-admin').each(function () {
            this.style.setProperty('display', 'none', 'important');
        });
        setupTeacherProfilePhotoForNormalUser();
        $('.display-name').hide();
        $('.js-teacher-share-tools').hide();
        $('.js-teacher-share-tools').html('');
        $('.js-monthly-giving').show();
        $('.js-view-classroom-description').show();
        $('.js-edit-classroom-description-form').remove();
        addClassroomDescriptionReadMoreLinkOnlyIfTooLong();
        $('.js-classroom-updates').css('display', 'inline-block');
    }
}

function renderAndShowTeacherShareBar() {
    const targetElement = document.getElementById('teacher-share-tools');
    $(targetElement).show();
    ReactDOM.render(
        <TeacherShareBar
            teacherProfileURL={teacherPageInfo.teacherProfileURL}
            pageName={pageName}
            tafURL={teacherPageInfo.tafURL}
            getTafEmail={getTafEmail} // defined in general/sharebar.js
            getTrackingLink={getTrackingLink} // defined in queryParams.js
            facebookAppId={facebookAppId}
            getTeacherProfileTwitterText={getTeacherProfileTwitterText} // defined in sharebar/sharebarHelperFunctions.js
            root={targetElement}
        />,
        targetElement,
    );
}
